import {useFiltersCache} from './use_filters_cache'

// You may pass 'name' and 'orgCacheKey' optionally if you need to access the Redux store values from
// within the context, when the provider has not been rendered.
export const useFilterCache = ({filterName, name, orgCacheKey} = {}) => {
	const filtersCache = useFiltersCache({name, orgCacheKey})

	return filtersCache[filterName] || []
}
